/**
 * Route are used by application to handle routing logic
 */
export enum RouteEnum {
  AGENT_PLATFORM = 'agent-platform',
  AP_NOV2024_ENGLISH = 'ap-nov2024-english',
  AP_SPANISH = 'ap-spanish',
  AP_PORTUGUESE = 'ap-portuguese',
  AP_JAPANESE = 'ap-japanese',
  ANNOUNCEMENT = 'announcement',
  BEYOND_CX = 'beyond-cx',
  CERTIFICATIONS_TRAINING_GENESYS_TECHNICAL_CERTIFICATION_GUIDE_REDIRECT = 'certification-training-genesys-technical-certification-guide-redirect',
  CERTIFICATIONS_TRAINING_GENESYS_TECHNICAL_CERTIFICATION_GUIDE = 'certification-training-genesys-technical-certification-guide',
  CERTIFICATIONS_TRAINING = 'certifications-training',
  COURSE = 'course',
  DASHBOARD = 'dashboard',
  HOME_EMPTY_PATH = 'home-empty-path',
  HOME = 'home',
  LEARNING_PATH_REDIRECT = 'learning-path-redirect',
  LEARNING_PATH = 'learning-path',
  MESSAGE_INBOX = 'message-inbox',
  PRODUCTS = 'products',
  SEARCH = 'search',
  SUBSCRIPTION_GENESYS_CLOUD = 'subscription-genesys-cloud',
  SUBSCRIPTION_AI_SUB = 'ai-subscription',
  SUBSCRIPTION_GENESYS_ENGAGE = 'subscription-genesys-engage',
  SUBSCRIPTION_POINTILLIST_REDIRECT = 'subscription-pointillist',
  SUBSCRIPTION_POINTILLIST = 'subscription-poinillist',
  SUBSCRIPTION_PURECONNECT = 'subscription-pureconnect',
  SUBSCRIPTION = 'subscription',
  TRAINING_SUPPORT_ELEARNING_GENESYS_DX = 'training-support-elearning-genesys-dx',
  TRAINING_SUPPORT_ELEARNING_GENESYS_CLOUD_CX = 'training-support-elearning-genesys-cloud-cx',
  TRAINING_SUPPORT_LEGACY_ELEARNING_GENESYS_CLOUD = 'genesys-cloud-elearning',
  TRAINING_SUPPORT_GENESYS_CLOUD = 'training-support-genesys-cloud',
  TRAINING_SUPPORT_GENESYS_CLOUD_CX_ELEARNING = 'training-support-genesys-cloud-cx-elearning',
  TRAINING_SUPPORT_GENESYS_DX_ELEARNING = 'training-support-genesys-dx-elearning',
  TRAINING_SUPPORT_Quick_Start_Guide = 'training-support-quick-start-guide',
  TRAINING_SUPPORT = 'training-support',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  TERMS_AND_CONDITIONS_2022 = 'terms-and-conditions-2022',
  VIDEOS = 'videos',
  VIDEO_DETAIL = 'video-detail',
  VOUCHER_REDEMPTION = 'voucher-redemption',
}
